import React from "react";
import { Badge } from "react-bootstrap";
import { BadgeProps } from "react-bootstrap/Badge";

type TemplateStatus = "live" | "draft" | "unpublished";

type StatusDisplay = { label: string } & Pick<BadgeProps, "variant">;

const statusConfig: Record<TemplateStatus, StatusDisplay> = {
  live: { variant: "success", label: "LIVE" },
  draft: { variant: "warning", label: "DRAFT" },
  unpublished: { variant: "secondary", label: "UNPUBLISHED" },
};

function getStatus(
  liveTemplate: string | null | undefined,
  draftTemplate: string | null | undefined,
): TemplateStatus {
  if (draftTemplate && liveTemplate) return "draft";
  if (draftTemplate) return "unpublished";
  if (liveTemplate) return "live";
  return "unpublished";
}

type TemplateStatusBadgeProps = {
  liveTemplate: string | null | undefined;
  draftTemplate: string | null | undefined;
};

function TemplateStatusBadge({
  liveTemplate,
  draftTemplate,
}: TemplateStatusBadgeProps) {
  const { variant, label } =
    statusConfig[getStatus(liveTemplate, draftTemplate)];
  return <Badge variant={variant}>{label}</Badge>;
}

export default TemplateStatusBadge;
